import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles((theme) => ({
  root: {
    marginTop: (isMobile) => (isMobile ? 16 : 24),
    height: theme.props.contentHeight,
    margin: "0 -12px",
    padding: "0 12px",
    alignContent: "flex-start",
    paddingBottom: 24,
  },
  paper: {
    width: "100%",
    backgroundColor: theme.props.backgroundSecondary,
    borderRadius: 10,
    overflow: "hidden",
    border: `1px solid ${theme.props.border}`,
    padding: "24px 32px",
    boxSizing: "border-box",
    height: "max-content",
    position: "sticky",
    top: 36,
  },
  contentContainer: {
    padding: (isMobile) => (isMobile ? 0 : 32),
    // backgroundColor: theme.props.backgroundSecondary,
    height: "100%",
  },
  button: {
    width: "max-content",
    "&:first-child": { marginRight: 24 },
  },
  mobileDrawerButton: {
    margin: "5px 3px -5px 3px",
  },
}));

export default useStyle;
